module.exports = __webpack_public_path__ + "static/media/landing-bulk-messaging.011ca953.png";